module.exports = __webpack_public_path__ + "3c8bea2c3fd27a52ef67923cf57d6040.pdf";